import React, { Component } from 'react';
import { confirmAlert } from 'react-confirm-alert';
//id_complemento, id_producto, id_preferencia, id_adicional,
// id_producto_complemento, etiqueta, maximo, defecto
class getConfiguracionCombo extends Component {
  constructor(props){
    //id_complemento, id_producto, id_preferencia, id_adicional, id_producto_complemento, etiqueta,
    // maximo, defecto, precio, orden_global, orden, observacion_adicional, cant_minima, porc_descuento
    super(props);
    this.state = {
        id_producto_modal :this.props.id_producto_modal,
        id_producto:0,
        detalle_complemento : [],
        id_tipo_complemento :0,
        tipo_complemento:[
          {
            "id_tipo_complemento":0, "tipo_complemento":"Preferencia"
          },
          {
            "id_tipo_complemento":1, "tipo_complemento":"Adicional"
          },
          {
            "id_tipo_complemento":2, "tipo_complemento":"Combo"
          }
        ],
        producto :[],
        new_etiqueta :'',
        new_cantidad_maxima:'',
        new_cantidad_defecto:'',
        new_precio:'',
        new_orden_global:0,
        new_observacion_adicional:'',
        new_cant_minima:0,
        new_porc_descuento:0,
        msg_loading:false
    }
  }
  get_loading =(msg_loading)=>{
    this.setState({
      msg_loading
    })
  }

  getEliminarComplemento =(id_complemento)=>{
    confirmAlert({
      title: 'Eliminar Complemento',
      message: '¿Desea Eliminar Complemento?',
      buttons: [
        {
          label: 'Sí',
          onClick: () => {
            this.getDeleteComplemento(id_complemento)

          }
        },
        {
          label: 'No',
          onClick: () => this.get_opcion_no()
        }
      ]
    })
  }
  get_opcion_no =()=>{

  }
  getDeleteComplemento =(id_complemento)=>{
    const url= this.props.dir_url + "webapp/getDeleteComplemento";
    const token =  this.props.token
    var obj = { accion:'deletecomplemento',token,id_complemento};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      this.get_loading(false)
      this.cargar_complementos()
    })
    .catch(console.log)
      this.get_loading(true)
  }

  llenar_complementos =()=>{
    /*new_orden_global:0,
    new_observacion_adicional:'',
    new_cant_minima:0,
    new_porc_descuento:0,*/

    const detalle_complemento = this.state.detalle_complemento
    return(
       <React.Fragment>
        {(detalle_complemento.length>0)?
          <React.Fragment>
          <tbody>
          {detalle_complemento.map((detalle , index) => (
            <tr key={index}>
              <td>
                {detalle.complemento}
              </td>
              <td>
                {detalle.producto}
              </td>
              <td>
                {detalle.etiqueta}
              </td>
              <td>
                {detalle.maximo}
              </td>
              <td>
                {detalle.precio}
              </td>
              <td>
                {detalle.defecto}
              </td>
              <td>
                {detalle.orden}
              </td>
              <td>
                {detalle.observacion_adicional}
              </td>
              <td>
                {detalle.cant_minima}
              </td>
              <td>
                {detalle.porc_descuento}
              </td>
              <td>
                <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getEliminarComplemento(detalle.id_complemento)}>
                  Eliminar
                </button>
                <br/>
              </td>
            </tr>
          ))}
          </tbody>
          </React.Fragment>
           :''
      }
      </React.Fragment>
    )
  }
  /*new_orden_global:0,
  new_observacion_adicional:'',
  new_cant_minima:0,
  new_porc_descuento:0,*/

  getnewrComplemento =()=>{
    //id_complemento, id_producto, id_preferencia, id_adicional, id_producto_complemento, , , ,
    const id_tipo_complemento = this.state.id_tipo_complemento
    let precio = this.state.new_precio
    let etiqueta = this.state.new_etiqueta.trim()
    let maximo = this.state.new_cantidad_maxima
    let defecto = this.state.new_cantidad_defecto

    let orden_global = this.state.new_orden_global
    let observacion_adicional = this.state.new_observacion_adicional.trim()
    let cant_minima = this.state.new_cant_minima
    let porc_descuento = this.state.new_porc_descuento



    const id_producto = this.state.id_producto_modal
    let id_preferencia = 0
    let id_adicional = 0
    let id_producto_complemento = 0
    if(Number(id_tipo_complemento)===0){
      id_preferencia =this.state.id_producto
      if(Number(id_preferencia)===0){
        alert("Ingrese Preferencia")
        return null
      }
      precio=0
      etiqueta=''
      maximo=0
      defecto=0
    }
    if(Number(id_tipo_complemento)===1){
      id_adicional =this.state.id_producto
      if(Number(id_adicional)===0){
        alert("Ingrese Adicional")
        return null
      }
      //console.log(precio)
      if(Number(precio)<=0){
        alert("Ingrese Precio")
        return null
      }
      etiqueta=''
      //maximo=0
      defecto=0
    }
    if(Number(id_tipo_complemento)===2){
      id_producto_complemento =this.state.id_producto
      if(Number(id_producto_complemento)===0){
        alert("Ingrese Producto")
        return null
      }
      if(etiqueta===''){
        alert("Ingrese Etiqueta")
        return
      }
      precio=0
    }


    //constid_producto, id_preferencia, id_adicional, id_producto_complemento
    //id_complemento, id_producto, id_preferencia, id_adicional, id_producto_complemento, etiqueta, maximo, defecto, precio

    const url= this.props.dir_url + "webapp/getNewComplemento";
    const token =  this.props.token
    var obj = { accion:'newcomplemento',token,id_producto, id_preferencia, id_adicional, id_producto_complemento,
     etiqueta, maximo, defecto, precio,orden_global,observacion_adicional,cant_minima,porc_descuento  };
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
    this.get_loading(false)
    this.cargar_complementos()
    })
    .catch(console.log)
    this.get_loading(true)
  }
 regresar =()=>{
   this.props.getSalirComplementos()
 }

  cargar_complementos =()=>{
    const id_producto = this.state.id_producto_modal
    const url= this.props.dir_url + "webapp/getDataComplementos";
    const token =  this.props.token
    var obj = { accion:'datacomplementos', token, id_producto};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      if(data[0].status==="ok"){
        this.setState({
          producto : data[0].msg,
          detalle_complemento : data[0].msg2
        })
      }
    })
    .catch(console.log)
  }

  handleChange_new= (event ,name) => {
    let value = event.target.value
    if(name==="id_tipo_complemento"){
      this.setState({
        id_tipo_complemento : value
      })
    }
    if(name==="id_producto"){
      this.setState({
        id_producto : value
      })
    }
    if(name==="etiqueta"){
      this.setState({
        new_etiqueta : value
      })
    }
    if(name==="cantidad_maxima"){
      this.setState({
        new_cantidad_maxima : value
      })
    }
    if(name==="cantidad_defecto"){
      this.setState({
        new_cantidad_defecto : value
      })
    }
    if(name==="precio"){
      this.setState({
        new_precio: value
      })
    }
    if(name==="orden_global"){
      this.setState({
        new_orden_global: value
      })
    }
    if(name==="observacion_adicional"){
      this.setState({
        new_observacion_adicional: value
      })
    }
    if(name==="cant_minima"){
      this.setState({
        new_cant_minima: value
      })
    }
    if(name==="porc_descuento"){
      this.setState({
        new_porc_descuento: value
      })
    }
  }

  render() {
    //<GetUploadImage file_xxx={'app-delivery-8b998-60x60'}  firebase={firebase} getUUID={this.getUUID} width={'60px'} height={'60px'}  token_image={''} />
    //id_datos_empresa, logo, datos_empresa, condiciones
    let modal_loading
    const msg_loading = this.state.msg_loading
    if(msg_loading){
      modal_loading = <div id="loader" className="loader loader-default is-active" data-text=""></div>
    }
    const tipo_complemento = this.state.tipo_complemento
    const producto = this.state.producto
    const id_tipo_complemento = this.state.id_tipo_complemento
    return(
      <React.Fragment>
      <div className="" style={{"backgroundColor":"white","color":"black"}}>
        <div className="grid-container_">
          <div className="lbl_imagen_" onClick={ () => this.regresar()}><img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } /></div>
          <div className="lbl_text_">Complementos</div>
        </div>
      </div>
      <div style={{"backgroundColor":"white","height":"100%","color":"black","overflowY": "auto"}}>
        <table className="tb_pedidos">
          <thead>
          <tr>
            <th>Campo</th>
            <th>Valor</th>
          </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tipo de Complemento</td>
              <td>
                <select className="select-css_global" value={this.state.id_tipo_complemento} onChange={(e) =>{this.handleChange_new( e ,  "id_tipo_complemento")}}>
                {(tipo_complemento.length !== 0) ?
                  tipo_complemento.map((tipo_complemento,index) => (
                    <option key={index} value={tipo_complemento.id_tipo_complemento} >{tipo_complemento.tipo_complemento}</option>
                  ))
                  : <React.Fragment></React.Fragment>
                }
                </select>
              </td>
            </tr>
            <tr>
              <td>{
                (Number(id_tipo_complemento)===0)?
                'Preferencia':
                (Number(id_tipo_complemento)===1)?
                'Adicional' : 'Producto'
              }</td>
              <td>
                <select className="select-css_global" value={this.state.id_producto} onChange={(e) =>{this.handleChange_new( e ,  "id_producto")}}>
                <option value="0">Seleccione {
                  (Number(id_tipo_complemento)===0)?
                  'Preferencia':
                  (Number(id_tipo_complemento)===1)?
                  'Adicional' : 'Producto'
                }</option>
                {(producto.length !== 0) ?
                  producto.map((producto,index) => (
                    <React.Fragment key={index} >
                    {(Number(id_tipo_complemento)===0)?
                      (Number(producto.tipo)===1)?
                      <option value={producto.id_producto} >{producto.producto}</option>
                      :''
                    :(Number(producto.tipo)===0)?
                    <option value={producto.id_producto} >{producto.producto}</option>
                    :''
                    }
                    </React.Fragment>
                  ))
                  : ''
                }
                </select>
              </td>
            </tr>

            {
              (Number(id_tipo_complemento)===2)?
              <React.Fragment>
                <tr>
                  <td>Etiqueta</td>
                  <td> <input  type="text" value={this.state.new_etiqueta|| ''} onChange={(e) => {this.handleChange_new( e   ,"etiqueta")}} /> </td>
                </tr>
                <tr>
                  <td>Cantidad Máxima</td>
                  <td> <input  type="text" value={this.state.new_cantidad_maxima|| ''} onChange={(e) => {this.handleChange_new( e   ,"cantidad_maxima")}}/> </td>
                </tr>
                <tr>
                  <td>Cantidad por Defecto</td>
                  <td> <input  type="text" value={this.state.new_cantidad_defecto|| ''} onChange={(e) => {this.handleChange_new( e   ,"cantidad_defecto")}}/> </td>
                </tr>
              </React.Fragment>
              :  ''
            }
            {
              (Number(id_tipo_complemento)===1)?
              <React.Fragment>
                <tr>
                  <td>Precio</td>
                  <td> <input  type="text" value={this.state.new_precio|| ''} onChange={(e) => {this.handleChange_new( e   ,"precio")}} /> </td>
                </tr>
                <tr>
                  <td>Cantidad Máxima</td>
                  <td> <input  type="text" value={this.state.new_cantidad_maxima|| ''} onChange={(e) => {this.handleChange_new( e   ,"cantidad_maxima")}}/> </td>
                </tr>
                <tr>
                  <td>Orden</td>
                  <td> <input  type="text" value={this.state.new_orden_global|| ''} onChange={(e) => {this.handleChange_new( e   ,"orden_global")}} /> </td>
                </tr>
                <tr>
                  <td>Observación Adicional</td>
                  <td> <input  type="text" value={this.state.new_observacion_adicional|| ''} onChange={(e) => {this.handleChange_new( e   ,"observacion_adicional")}} /> </td>
                </tr>
                <tr>
                  <td>Cantidad Mínima</td>
                  <td> <input  type="text" value={this.state.new_cant_minima|| ''} onChange={(e) => {this.handleChange_new( e   ,"cant_minima")}} /> </td>
                </tr>
                <tr>
                  <td>% Descuento</td>
                  <td> <input  type="text" value={this.state.new_porc_descuento|| ''} onChange={(e) => {this.handleChange_new( e   ,"porc_descuento")}} /> </td>
                </tr>
              </React.Fragment>:''
            }

            <tr>
              <td colSpan="2">
                <button style={{"width":"150px"}} className="button-global" onClick={ () => this.getnewrComplemento()}>
                  Crear Nueva Complemento
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <table className="tb_pedidos">
          <thead>
          <tr>
            <th>Tipo</th>
            <th>Producto</th>
            <th>Etiqueta</th>
            <th>Máximo</th>
            <th>Precio</th>
            <th>Cantidad x Defecto</th>
            <th>Orden</th>
            <th>Observación Adicional</th>
            <th>Cantidad Mínima</th>
            <th>% Descuento</th>
            <th>Opciones</th>
          </tr>
          </thead>
          {this.llenar_complementos()}
        </table>
        <br/><br/><br/><br/><br/>
      </div>
      {modal_loading}
      </React.Fragment>
    )
  }

  componentDidMount (){
    this.cargar_complementos()
  }
}
export default getConfiguracionCombo;
